import { Component, Input, Output, EventEmitter } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-default-edit-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './default-edit-dialog.component.html',
  styleUrls: ['./default-edit-dialog.component.css']
})
export class DefaultEditDialogComponent {
  @Input() mapEntity: { name: string } = { name: '' };
  @Output() ok = new EventEmitter<{ name: string }>();

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  onOk(): void {
    this.ok.emit(this.mapEntity);
    this.activeModal.close({ action: 'updated', entity: this.mapEntity });
  }

  onCancel(): void {
    this.activeModal.close({ action: 'cancelled', entity: this.mapEntity });
  }
}